/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './IndexGuides.module.scss';

import { IndexSection } from '../../atoms/IndexSection/IndexSection';
import type { IndexGuidesProps } from './IndexGuides.types';

export const IndexGuides = ({ guides, className }: IndexGuidesProps) => {
  const { t } = useInt();

  if (!guides.length) {
    return null;
  }

  return (
    <IndexSection
      title={t('Put the concepts into a country context.')}
      aside={t('Registry guides that show where each concept meets an official source.')}
      className={className}
    >
      <ul className={styles['grid']}>
        {guides.map((guide) => (
          <li key={guide.slug} className={styles['cell']}>
            <a href={guide.url} target="_blank" rel="noopener noreferrer" className={styles['card']}>
              <span className={styles['art']}>{guide.code}</span>

              <span className={styles['tag']}>
                {guide.region} {t('registry guide')}
              </span>

              <span className={styles['title']}>{guide.title}</span>

              <span className={styles['description']}>{guide.desc}</span>

              <span className={styles['more']}>
                {t('Open guide')}
                <Icon type="arrow-forward" />
              </span>
            </a>
          </li>
        ))}
      </ul>
    </IndexSection>
  );
};
